import { createSlice, createSelector } from '@reduxjs/toolkit';
import { edgeApi } from '../services/edgeApi';

let localActiveOverlayIds;

try {
  localActiveOverlayIds = JSON.parse(localStorage.getItem('activeOverlayIds'));
} catch (e) {
  console.warn(e);
}

const initialState = {
  activeOverlayIds: localActiveOverlayIds || [],
  modal: false,
};

export const overlaysSlice = createSlice({
  name: 'overlays',
  initialState,
  reducers: {
    updateActiveOverlayIds: (state, action) => ({
      ...state,
      activeOverlayIds: action.payload,
    }),

    setModal: (state, action) => {
      return { ...state, modal: action.payload };
    },
  },
});

export const updateActiveOverlaysThunk = (payload) => (dispatch, getState) => {
  let { activeOverlayIds } = getState().overlays;
  const payloadId = Number(payload.id);

  if (payload.value === true) {
    activeOverlayIds = [...activeOverlayIds, payloadId];
  } else {
    activeOverlayIds = activeOverlayIds.filter(
      (overlayId) => overlayId != payloadId,
    );
  }

  try {
    localStorage.setItem('activeOverlayIds', JSON.stringify(activeOverlayIds));
  } catch (e) {
    console.warn('Could not store active overlay ids in localStorage', e);
  }
  dispatch(updateActiveOverlayIds(activeOverlayIds));
};

// initiate get map overlays query as a selector:
export const selectOverlaysResult = edgeApi.endpoints.getOverlays.select();

export const selectOverlays = createSelector(
  selectOverlaysResult,
  (overlaysResult) => overlaysResult?.data ?? [],
);

export const selectActiveOverlayIds = (state) =>
  state.overlays.activeOverlayIds;

export const selectActiveOverlays = createSelector(
  selectOverlays,
  selectActiveOverlayIds,
  (allOverlays, activeOverlayIds) =>
    allOverlays.filter((overlay) => activeOverlayIds.includes(overlay.id)),
);

export const { updateActiveOverlayIds, setModal } = overlaysSlice.actions;

export default overlaysSlice.reducer;
